<!-- Content -->
<div class="container">
	<div class="row">
		<div class="col-md-12">
			<h1>Firma de documento</h1>
			<p>Escriba su firma y guarde</p>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<canvas id="sig-canvas" width="300" height="100">
				Get a better browser, bro.
			</canvas>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<button class="btn btn-primary" id="sig-submitBtn">Guardar Firma</button>
			<button class="btn btn-default" id="sig-clearBtn">Limpiar firma</button>
		</div>
	</div>
	<br />
	<div class="row">
		<div class="col-md-12">
			<textarea id="sig-dataUrl" style="display: none;" class="form-control fs-5"
				rows="5">Data URL for your signature will go here!</textarea>
		</div>
	</div>
	<br />
	<div class="row">
		<div class="col-md-6">
			<img id="sig-image" [hidden]="isHidden" class="sig-image" src="" alt="Vista preliminar" />
		</div>
	</div>
</div>